import {
  observable,
  computed,
  action,
  useStrict,
  runInAction,
  autorun,
  isObservable,
  isObservableArray,
  isObservableMap
} from "mobx";
import BaseStore from "./BaseStore";
import storeAudioPlayer from "./storeAudioPlayer";
import { MEDIA_PLAYER_TARGET_TYPES } from "../consts/consts";
import foStorage from "../utils/foStorage";
import moment from "moment";
import zhugeio from "../utils/zhugeio";

useStrict(true);

const INTERVAL = 10 * 1000;
const TODAY = moment().format("YYYY-MM-DD");

class StorePlayerStatistics extends BaseStore {
  constructor() {
    super();
    this.doRecordDuration = this.doRecordDuration.bind(this);

    this.readStorageData();
  }
  @observable
  audioTargetInfo = null;
  @observable
  videoTargetInfo = null;
  @observable
  videoDom;
  /**
   *
   * @returns {
   *
   *  '2018-01-22': {
   *    'type|type_id':{
   *      type,
   *      type_id,
   *      parent_id,
   *      title,
   *      parent_title,
   *      duration, // 单位为秒
   *    }
   *  },
   *  '2018-01-21': {
   *    'type|type_id':{
   *      type,
   *      type_id,
   *      parent_id,
   *      title,
   *      parent_title,
   *      duration,
   *    }
   *  },
   *
   * }
   *
   */
  storageData = {};

  get audioPaused() {
    return storeAudioPlayer.paused;
  }

  get videoPaused() {
    if (this.videoDom) {
      return this.videoDom.paused;
    }
    return true;
  }

  readStorageData() {
    this.storageData = foStorage.getItem(foStorage.KEYS.playerDurations) || {};
    console.log(this.storageData);
  }

  saveStorageData() {
    foStorage.setItem(foStorage.KEYS.playerDurations, this.storageData);
  }

  initStatistics() {
    this.doRecordDuration();
    setInterval(this.doRecordDuration, INTERVAL);
  }

  submitTargetInfoToZhugeIO(targetInfo) {
    /*
    {
   *      type,
   *      type_id,
   *      parent_id,
   *      title,
   *      parent_title,
   *      duration,
   *      date,
    }
     */
    const {
      type,
      type_id,
      parent_id,
      title,
      parent_title,
      duration,
      date
    } = targetInfo;
    let typeText = "未知类型";
    if (type === MEDIA_PLAYER_TARGET_TYPES.column) {
      typeText = "订阅详情";
    }
    if (type === MEDIA_PLAYER_TARGET_TYPES.lesson) {
      typeText = "课时详情";
    }
    if (type === MEDIA_PLAYER_TARGET_TYPES.article) {
      typeText = "文章详情";
    }
    if (type === MEDIA_PLAYER_TARGET_TYPES.qa) {
      typeText = "问答";
    }
    if (type === MEDIA_PLAYER_TARGET_TYPES.live) {
      typeText = "直播";
    }
    if (type === MEDIA_PLAYER_TARGET_TYPES.vod) {
      typeText = "回看";
    }

    zhugeio.track("总播放时长", {
      类别: typeText,
      类别ID: type_id,
      父类别ID: parent_id || 0, // 课程ID | 专栏ID
      类别标题: title,
      父类别标题: parent_title || "",
      时长: duration,
      日期: date
    });
  }
  submitZhugeIO() {
    const dates = Object.keys(this.storageData);
    dates.forEach(date => {
      if (date !== TODAY) {
        Object.values(this.storageData[date]).forEach(targetInfo => {
          targetInfo.date = date;
          this.submitTargetInfoToZhugeIO(targetInfo);
        });
        const _storageData = this.storageData;

        delete _storageData[date];
        this.storageData = _storageData;
        this.saveStorageData();
      }
    });
  }
  getTargetFromStorageData(targetInfo) {
    const targetKey = `${targetInfo.type}|${targetInfo.type_id}`;
    if (!this.storageData[TODAY]) {
      this.storageData[TODAY] = {};
    }
    if (!this.storageData[TODAY][targetKey]) {
      this.storageData[TODAY][targetKey] = targetInfo;
    }
    const _targetInfo = this.storageData[TODAY][targetKey];
    return _targetInfo;
  }

  addDuration(targetInfo) {
    const _targetInfo = this.getTargetFromStorageData(targetInfo);
    const { duration, ...others } = targetInfo;
    Object.assign(_targetInfo, others);
    _targetInfo.duration = (_targetInfo.duration || 0) + INTERVAL / 1000;
  }

  addAudioDuration() {
    if (this.audioPaused) {
      return;
    }
    console.log("audio: ----------------------------------------------------");
    /*
    {
        type: MEDIA_PLAYER_TARGET_TYPES.lesson, //"课时详情",
        type_id: target.id,
        parent_id: target.lesson_id, // 课程ID | 专栏ID
        title: target.title,
        parent_title: target.lesson_title,
        duration: 0
     }
     */
    console.log(this.audioTargetInfo);
    console.log(this.audioPaused);

    this.addDuration(this.audioTargetInfo);
  }

  addVideoDuration() {
    if (this.videoPaused) {
      return;
    }
    console.log("video: ----------------------------------------------------");
    console.log(this.videoTargetInfo);
    console.log(this.videoPaused);

    this.addDuration(this.videoTargetInfo);
  }

  doRecordDuration() {
    this.submitZhugeIO();

    if (this.audioPaused && this.videoPaused) {
      return;
    }

    this.readStorageData();
    console.log("StorePlayerStatistics");

    this.addAudioDuration();
    this.addVideoDuration();

    this.saveStorageData();
  }
}

export default new StorePlayerStatistics();



// WEBPACK FOOTER //
// ./src/store/storePlayerStatistics.js